import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/** MSAL Configuration that provides 
 * required informations for ContextAPI Application */
const msalCfg: Configuration = {
    auth: {
        clientId:    "b4895c03-dc9b-4179-910b-5a2955edae1e",
        authority:   "https://login.microsoftonline.com/05d133c6-5f2d-4b6a-b152-59ed56292a0a",
        redirectUri: window.location.origin + "/blank.html"
    },
    cache: {
        cacheLocation: "sessionStorage"
    }
}
/** Exports msalClient application for WebContext API 
 *  Wrap initilaize method for clientApplication within an async function 
 *  as current target doesn't suport top level await 
 */

export const msalClientApplication = new PublicClientApplication(msalCfg);

root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
